import { render, staticRenderFns } from "./HorizontalLineView.vue?vue&type=template&id=3b54450c"
import script from "./HorizontalLineView.vue?vue&type=script&lang=js"
export * from "./HorizontalLineView.vue?vue&type=script&lang=js"
import style0 from "./HorizontalLineView.vue?vue&type=style&index=0&id=3b54450c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports